import classNames from 'classnames';

import styles from './Section.module.scss';

export interface SectionProps {
	className?: string;
	children: React.ReactNode;
}

export const Section: React.FC<SectionProps> = ({ children, className }) => {
	return <div className={classNames(styles.Section, className)}>{children}</div>;
};
